import { BillingDataPeriod } from 'reactApp/api/billing/data/BillingDataAPICall.types';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import type { Product } from 'reactApp/types/Billing';
import { isMonthPeriod, isYearPeriod } from 'reactApp/utils/Period';

export function usePromoPeriod({ product, subscription }: { product: Product; subscription?: BillingDataSubscriptionInfo }) {
    const isMonth = isMonthPeriod(product.period);
    const isYear = isYearPeriod(product.period);
    const trialPeriod = !product?.isForceDiscountTrial && product?.trialPeriod;
    const discountPeriod =
        (isMonth || isYear) && product?.discountPeriodCount
            ? `${product.discountPeriodCount}${isMonth ? 'm' : 'y'}`
            : product?.discountPeriod;

    // Если нет подписки, значит мы во флоу покупки
    if (!subscription) {
        return trialPeriod || discountPeriod;
    }

    // флоу продления
    if (
        // если мы в триале или дисконте
        subscription.currentPeriod !== BillingDataPeriod.REGULAR &&
        // и если продление еще не переводит в регулярный период
        subscription.renewalCost !== product.price
    ) {
        return discountPeriod;
    }
    return;
}
